const FILEKIT_DOMAIN = new URL(
  process.env.FILEKIT_HOST || "https://convertkit.com"
).hostname
  .split(".")
  .slice(-2)
  .join(".")

export default function isFileKitURL(url) {
  if (!url) return false
  return url.includes(FILEKIT_DOMAIN)
}
